import React from "react";
import { Phone, Share2, ContactRound, MapPin, CheckCircle2, Sparkles } from "lucide-react";
import Logo from "../Logo";
import WhatsAppIcon from "../WhatsAppIcon";
import { COMPANY } from "../../lib/constants";

function DottedBackground() {
  return (
    <svg className="absolute inset-0 w-full h-full opacity-[0.13]" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="card-dots" x="0" y="0" width="22" height="22" patternUnits="userSpaceOnUse">
          <circle cx="1.5" cy="1.5" r="1.5" fill="white" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#card-dots)" />
    </svg>
  );
}

export default function CardHero({ initials, name, designation, phoneDigits, waLink, onShare, onSave }) {
  return (
    <div className="relative text-white overflow-hidden">
      <div className="absolute inset-0 hero-gradient" />
      <DottedBackground />
      <div className="absolute -right-16 -top-16 w-72 h-72 rounded-full bg-[var(--melopa-gold)]/35 blur-3xl" />
      <div className="absolute -left-20 -bottom-20 w-80 h-80 rounded-full bg-[var(--melopa-green)]/30 blur-3xl" />

      <div className="relative p-6 md:p-9">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <Logo size={42} tone="pill" />
            <div className="leading-tight">
              <div className="font-bold text-[15px] md:text-base">{COMPANY.name}</div>
              <div className="text-[10px] md:text-[11px] uppercase tracking-[0.2em] text-[var(--melopa-gold-soft)]">Digital Business Card</div>
            </div>
          </div>
          <button onClick={onShare} className="btn-outline-white text-[12px] md:text-sm !px-3 !py-2" data-testid="card-share-btn">
            <Share2 className="w-4 h-4" /> Share
          </button>
        </div>

        <div className="mt-7 md:mt-10 flex items-end gap-5">
          <div className="relative shrink-0">
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-gradient-to-br from-[var(--melopa-gold)] to-[var(--melopa-gold-soft)] grid place-items-center text-[#0b1f3b] text-2xl md:text-3xl font-extrabold shadow-[0_12px_30px_-10px_rgba(0,0,0,.5)] ring-4 ring-white/10">
              {initials}
            </div>
            <span className="absolute -bottom-1 -right-1 bg-[var(--melopa-green)] text-white rounded-full w-6 h-6 grid place-items-center border-2 border-[#0b1f3b]">
              <CheckCircle2 className="w-3.5 h-3.5" />
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[var(--melopa-gold)]/15 text-[var(--melopa-gold-soft)] text-[10.5px] font-bold uppercase tracking-[0.18em] border border-[var(--melopa-gold)]/30">
              <Sparkles className="w-3 h-3" /> {designation}
            </span>
            <h1 className="text-[26px] md:text-4xl font-extrabold tracking-tight leading-[1.1] mt-2">{name}</h1>
            <div className="h-1 w-14 rounded-full bg-[var(--melopa-gold)] mt-3" />
            <div className="text-white/80 text-sm mt-2 flex items-center gap-1.5">
              <MapPin className="w-3.5 h-3.5 text-[var(--melopa-gold-soft)]" /> Bengaluru, Karnataka, India
            </div>
          </div>
        </div>

        <div className="mt-7 grid grid-cols-3 gap-2.5">
          <a href={`tel:+91${phoneDigits}`} className="btn-white !py-3 justify-center text-[13px] md:text-sm" data-testid="card-call-quick">
            <Phone className="w-4 h-4" /> Call
          </a>
          <a href={waLink} target="_blank" rel="noreferrer" className="btn-green !py-3 justify-center text-[13px] md:text-sm" data-testid="card-wa-quick">
            <WhatsAppIcon className="w-4 h-4" /> WhatsApp
          </a>
          <button onClick={onSave} className="btn-gold !py-3 justify-center text-[13px] md:text-sm" data-testid="card-vcf">
            <ContactRound className="w-4 h-4" /> Save
          </button>
        </div>
      </div>
    </div>
  );
}
